<template>
  <main class="content">
        <header class="content-header">
            <section class="content-header-section">
                <router-link :to="`/${ $options.module }`" class="button button-back">
                    {{ $t('general.form.buttons.back') }}
                </router-link>
            </section>
            <section class="content-header-section"></section>
        </header>
        <div class="content-top">
            <div class="content-top-lang" v-click-outside="langClose">
                <div class="content-top-lang-value" @click="langToggle">{{ lang }}</div>
                <ul v-if="langIsOpen" class="content-top-lang-select">
                    <li
                        v-for="language in $options.languages"
                        :key="language"
                        :class="{ selected: lang === language }"
                        @click="langClick(language)"
                    >
                        {{ language }}
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="viewElement" class="content-data">
          <div class="content-data-row">
            <p class="content-data-title">{{ $t(`pages.${ $options.module }.form.labels.timestamp`) }}</p>
            <p class="content-data-description">{{ formatDateTime(viewElement.senton) }}</p>
          </div>
          <div class="content-data-row">
            <p class="content-data-title">{{ $t(`pages.${ $options.module }.form.labels.notificationType`) }}</p>
            <p class="content-data-description">
              {{ getCountriesListForItem(viewElement) }}
               <span v-if="regions">({{ regions }})</span>
            </p>
          </div>
          <div class="content-data-row">
            <p class="content-data-title">{{ $t(`pages.${ $options.module }.form.labels.travelstatuses`) }}</p>
            <p class="content-data-description">{{ getTravelStatuses(viewElement) }}</p>
          </div>
          <div class="content-data-row">
            <p class="content-data-title">{{ $t(`pages.${ $options.module }.form.labels.title`) }}</p>
            <p class="content-data-description">{{ viewElement.locales[lang].title }}</p>
          </div>
          <div class="content-data-row">
            <p class="content-data-title">{{ $t(`pages.${ $options.module }.form.labels.description`) }}</p>
            <p class="content-data-description">{{ viewElement.locales[lang].description }}</p>
          </div>
          <div class="content-data-row">
            <p class="content-data-title">{{ $t(`pages.${ $options.module }.form.labels.urlText`) }}</p>
            <p class="content-data-description">
              <a class="content-data-link bold" target="_blank" :href="viewElement.locales[lang].url">{{ viewElement.locales[lang].urltext }}</a>
            </p>
          </div>
          <div class="content-data-row">
            <p class="content-data-title">{{ $t(`pages.${ $options.module }.form.labels.url`) }}</p>
            <p class="content-data-description">
              <a class="content-data-link" target="_blank" :href="viewElement.locales[lang].url">{{ viewElement.locales[lang].url }}</a>
            </p>
          </div>
        </div>
  </main>
</template>

<script>
import merge from 'lodash/merge';
import ListMixin from '@/components/list/ListMixin';
import languages, { defaultLanguage } from '@/config/languages';
import { travelstatuses } from '@/pages/notifications/NotificationsForm.vue';
import formatDateTime from '../../utils/formatDate';

export default {
    languages,
    mixins: [ListMixin],
    name: 'NotificationsView',
    module: 'notifications',
    listItemConfig: {},
    async created() {
        await this.$store.dispatch('countries/list');
        this.dataElement = await this.$store.dispatch(`${ this.$options.module }/get`, this.$route.params.id);
    },
    data() {
        return {
            lang: defaultLanguage,
            langIsOpen: false,
            dataElement: {},
            element: {
                senton: null,
                countryids: [],
                locales: {
                    de: {},
                    fr: {},
                    it: {},
                    en: {},
                },
            },
        };
    },
    computed: {
        viewElement() {
            if (typeof this.$route.params.id === 'undefined') {
                return null;
            }

            const id = parseInt(this.$route.params.id, 10);
            if (Number.isNaN(id) || id <= 0) {
                return null;
            }

            return merge({}, this.element, this.dataElement);
        },
        regions() {
            if (this.viewElement.countryids.length !== 1 || !this.viewElement.regioncodes.length) {
                return '';
            }

            return this.viewElement.regioncodes.join(', ').replace(this.$t('general.form.no_region'), this.$t('general.form.no_region_title'));
        },
    },
    methods: {
        langClose() {
            this.langIsOpen = false;
        },
        langToggle() {
            this.langIsOpen = !this.langIsOpen;
        },
        langClick(language) {
            this.langIsOpen = false;
            this.lang = language;
        },
        getCountriesListForItem(item) {
            if (item.countryids.length === 0) {
                return this.$t(`pages.${ this.$options.module }.form.values.allUsers`);
            }

            const countries = item.countryids.map((id) => this.$store.getters['countries/getById'](id));
            return countries
                .filter((country) => !!country)
                .map((country) => (country.locales[this.lang] && country.locales[this.lang].name) || country.locales[defaultLanguage].name)
                .join(', ');
        },
        getTravelStatuses(item) {
            return item.travelstatuses.map((id) => {
                const key = travelstatuses.find((status) => status.value === id).titleKey;
                return this.$t(`pages.${ this.$options.module }.form.values.${ key }`);
            }).join(', ');
        },
        formatDateTime,
    },
};
</script>
